import React from "react"
import "./color.css"

const Cancel = () => {
	return (
		<svg className="cancel" width="24" height="24" viewBox="0 0 24 24">
			<g id="Icons" transform="translate(5 5)">
				<g id="Outlined" transform="translate(-683 -1487)">
					<g id="Content" transform="translate(100 1428)">
						<g
							id="Outlined-_-Content-_-clear"
							data-name="Outlined-/-Content-/-clear"
							transform="translate(578 54)"
						>
							<g id="Group_152" data-name="Group 152">
								<path id="Path" d="M0,0H24V24H0Z" fill="none" fillRule="evenodd" />
								<path
									id="_-Icon-Color"
									data-name="🔹-Icon-Color"
									d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z"
									fill="#dc3545"
									fillRule="evenodd"
								/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
}

export default Cancel
